import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M97.5 50c0 11.08-8.775 20-19.676 20H22.175c-10.9 0-19.676-8.92-19.676-20s8.775-20 19.676-20h55.649c10.9 0 19.676 8.92 19.676 20" })
});
export default SvgPill;
